<template>
  <div class="main" :key="reRender">
    <basic-info-view :basicInfo="basicInfo"></basic-info-view>
    <experience-view :exp="exp"></experience-view>
    <education-view :edu="edu"></education-view>
    <skill-view :skills="skills"></skill-view>
    <project-view :project="project"></project-view>
    <language-view :lang="lang"></language-view>
    <training-view :train="train"></training-view>
  </div>
</template>

<script>
import { CANDIDATE_DETAILS } from "../../../Api/employer_api";
import BasicInfoView from "./basic-info-view";
import ExperienceView from "./experience-view";
import EducationView from "./education-view";
import SkillView from "./skills-view";
import ProjectView from "./project-view";
import LanguageView from "./language-view";
import TrainingView from "./training-view";
import { getOwnerInfo } from "../../../globalConstants";
export default {
  name: "view-profile",
  props:{
    id:{
      type:String,
      default:""
    }
  },
  data: function () {
    return {
      exp: [],
      edu: [],
      skills: [],
      project: [],
      lang: [],
      train: [],
      basicInfo:{},
      reRender: 0,
    };
  },
  components: {
    BasicInfoView,
    ExperienceView,
    EducationView,
    SkillView,
    ProjectView,
    LanguageView,
    TrainingView,
  },
  mounted() {
    CANDIDATE_DETAILS({user_id:this.id})
      .then((val) => {
        val.location_name&&(this.basicInfo.location_name=val.location_name)
        val.image_url&&(this.basicInfo.image_url=val.image_url)
        val.email&&(this.basicInfo.email=val.email)
        val.user_name&&(this.basicInfo.user_name=val.user_name)
        val.phone&&(this.basicInfo.phone=val.phone)
        val.company_name&&(this.basicInfo.company_name=val.company_name)
        val.institution_name&&(this.basicInfo.institution_name=val.institution_name)
        this.exp = val.experience;
        this.edu = val.education;
        this.lang = val.language;
        this.project = val.projects;
        this.skills = val.skill;
        this.train = val.training;
        this.reRender++;
      })
      .catch();
  },
};
</script>

<style scoped>
.main {
  background-color: white;
  padding: 2rem;
  overflow-y: auto;
  max-height: 90vh;
}
</style>
